/** 数字左侧补零（时钟 / lastSeen） */
export function pad2(n) {
  return String(n).padStart(2, '0');
}

/** 格式化为 HH:mm:ss；无效返回空串 */
export function formatLastSeen(value) {
  if (!value) return '';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
  } catch (_) {
    return '';
  }
}

/** 电量展示文案 */
export function formatBatteryText(batteryLevel) {
  return batteryLevel != null && batteryLevel !== ''
    ? `${batteryLevel}%`
    : '未知';
}

/** 电量色调：good / warn / low / unknown */
export function getBatteryTone(batteryLevel) {
  const n = Number(batteryLevel);
  if (!Number.isFinite(n)) return 'unknown';
  if (n >= 50) return 'good';
  if (n >= 20) return 'warn';
  return 'low';
}

/** 全屏信息条时钟 YYYY-MM-DD HH:mm:ss */
export function formatFullscreenClock(date = new Date()) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())} ${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
}
